import { Text } from "@kvix/ui";
import { Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  button: {
    cursor: "pointer",
  },
  itemMargin: {
    marginBottom: "8px",
  },
}));

interface Props {
  title: string;
  value: string | React.ReactNode;
  button?: React.ReactNode;
}

export const BillingRow: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { title, value, button } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Grid item className={isMobile && classes.itemMargin}>
      <Grid item container direction="row">
        <Grid item xs={12} md={6}>
          <Text align="left" weight={600}>
            {title}
          </Text>
        </Grid>
        <Grid item xs={12} md={6}>
          {typeof value === "string" ? (
            <Text align={isMobile ? "left" : "right"}>{value}</Text>
          ) : (
            value
          )}
        </Grid>
      </Grid>
      {button && (
        <Grid
          xs={12}
          alignItems={isMobile ? "flex-start" : "flex-end"}
          className={classes.button}
        >
          {button}
        </Grid>
      )}
    </Grid>
  );
};
